import React from "react";
import aboutus from '../assets/mahamadd.jpg';
import "./AboutUs.css";

const AboutUs = () => {
  return (
    <div className="responsive-container-block bigContainer">
      <div className="responsive-container-block Container">
   
        <div className="responsive-container-block textSide">
          <p className="text-blk heading">Administrator at Future MedsAcademy</p>
          {/* <h2>My Journey and the Vision Behind Future MedsAcademy</h2> */}
          <p className="text-blk subHeading">
          Maham Ovis is an Medicine and Surgery student at the University of Messina,
she has been living and studying for the past eight years in Italy. Her in-depth
understanding of Italian academic processes and administrative requirements
has positioned her as an expert in handling essential student documentation,
including scholarship applications and financial paperwork. Maham plays a key role at Future MedsAcademy, managing all aspects of student documentation  to ensure a seamless transition for aspiring medical students coming to italy.
          </p>
          {/* {[...Array(4)].map((_, index) => (
            <div
              key={index}
              className="responsive-cell-block wk-desk-6 wk-ipadp-6 wk-tab-12 wk-mobile-12"
            >
              <div className="cardImgContainer">
                <img
                  className="cardImg"
                  src="https://workik-widget-assets.s3.amazonaws.com/widget-assets/images/id2.svg"
                  alt="Value Icon"
                />
              </div>
              <div className="cardText">
                <p className="text-blk cardHeading">Value</p>
                <p className="text-blk cardSubHeading">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                </p>
              </div>
            </div>
          ))}
          <a href="#">
            <button className="explore">Read more</button>
          </a> */}
        </div>

        <div className="imgContainer">
          <img
            className="blueDots"
            src="https://workik-widget-assets.s3.amazonaws.com/widget-assets/images/aw3.svg"
            alt="background dots"
          />
          <img
            className="mainImg"
            src={aboutus}
            alt="Main"
          />
                <h1>Maham Ovis</h1>

        </div>
       
      </div>
    </div>
     );
    };
    
    export default AboutUs;